import React from 'react';
import {goldPackage, platinumPackage} from '../PackageDetails';
import styled from 'styled-components';
import PackagePriceCard from '../components/PackagePriceCard';

function ComparisonChart() {
    const ComparisonChart = styled.div`
        width: 100%;
        margin-bottom: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        button {
            margin-bottom: 20px;
            height: 40px;
            width: 100px;
            font-family: play;
            font-size: 16px;
            border-radius: 5px;
            cursor: pointer;
        }
    `;
    return (
        <ComparisonChart>
            <PackagePriceCard imgsrc={goldPackage.packageImg} imgalt='gold package img' barText={goldPackage.barText} options={goldPackage.options} description={goldPackage.description} name={goldPackage.name} price={goldPackage.price} alternatePrice={goldPackage.altPrice}/>
            <PackagePriceCard imgsrc={platinumPackage.packageImg} imgalt='platinum package img' barText={platinumPackage.barText} options={platinumPackage.options} description={platinumPackage.description} name={platinumPackage.name} price={platinumPackage.price} alternatePrice={platinumPackage.altPrice}/>
        </ComparisonChart>
    )
}

export default ComparisonChart;